import { debounce } from '@/utils/tool.js';
export class DrawWaterMark {
  constructor(fontText) {
    // 获取body
    this.bodyNode = document.querySelector('body');

    // 水印蒙版的宽高，给一个足够大的宽高,这样子保证页面窗口大小变化时，水印蒙版都能够覆盖窗口
    this.bodyWidth = 5000;
    this.bodyHeight = 5000;

    // 水印文字
    this.fontText = fontText;

    // 观察对象
    this.observer = null;

    // 初始化水印蒙版
    this.init();

    // 监测水印蒙版是否被人修改或者删除
    this.watchWatermaskChange();
  }

  // 初始化水印蒙版
  init() {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('id', 'watermask');
    // 如果不支持 canvas
    if (!canvas.getContext) {
      return;
    }
    // bodyNode.style.position = 'relative';
    canvas.width = this.bodyWidth;
    canvas.height = this.bodyHeight;
    // 通过 style 添加样式
    canvas.style.position = 'fixed';
    canvas.style.top = '-100px';
    canvas.style.left = '-100px';
    // canvas.style.opacity = 0.2;
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = 10000;

    this.bodyNode.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    this.draw(ctx);
  }

  // 绘制文字水印
  draw(ctx) {
    const fontTextAArr = this.fontText.split('');
    const textWidth = (fontTextAArr.length + 1) * 25;
    // 创建临时 canvas
    const width = textWidth;
    const height = textWidth;
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = width;
    tempCanvas.height = height;

    const tempCtx = tempCanvas.getContext('2d');
    // tempCtx.strokeStyle = '#000000'; // 设置描边颜色为黑色
    // tempCtx.lineWidth = 5; // 设置线条宽度为5像素
    // tempCtx.strokeRect(0, 0, width, height); // 绘制描边的矩形
    tempCtx.save();

    // 旋转 逆时针20 度让文字变倾斜
    tempCtx.rotate((Math.PI / 180) * -20);
    // tempCtx.font = '10px serif'; // 设置字体的大小
    tempCtx.font = '13px Microsoft Yahei, Tahoma, hiragino sans gb, Helvetica, Arial,sans-serif';
    tempCtx.fillStyle = 'rgba(150,150,150,0.2)'; // 设置绘制的颜色

    // 遍历水印内容
    fontTextAArr.forEach((text, index) => {
      tempCtx.fillText(text, (index - 1) * 20, height - 20); // 拉开20的间距
    });
    // 将文字水印布满水印蒙版
    const pattern = ctx.createPattern(tempCanvas, 'repeat');
    ctx.fillStyle = pattern;
    ctx.fillRect(0, 0, this.bodyWidth, this.bodyHeight);
  }

  // 更新水印的文字
  updateText(text) {
    // 修改文字
    this.fontText = text;
    const canvasEl = document.querySelector('#watermask');
    // 移除旧的水印canvas
    canvasEl && this.bodyNode.removeChild(canvasEl);
  }

  // 监测水印canvas是否被修改或者被删除，被修改或删除就重新生成
  watchWatermaskChange() {
    const callback = mutationsList => {
      console.log('触发了重绘-----');
      // 触发重绘
      let hasRedraw = false;
      mutationsList.forEach(recode => {
        // 如果是删除 canvas
        if (recode.target.localName === 'body') {
          recode.removedNodes.forEach(node => {
            if (node.localName === 'canvas') {
              this.init();
              hasRedraw = true;
            }
          });
        } else if (recode.target.localName === 'canvas') {
          this.bodyNode.removeChild(recode.target);
          hasRedraw = true;
        }
      });
      if (!hasRedraw) {
        const canvasEl = document.querySelector('#watermask');
        // 在控制台禁用js之后再打开，重新生成水印
        !canvasEl && this.init();
      }
    };

    this.observer = new MutationObserver(debounce(callback, 300));
    // this.observer = new MutationObserver(callback);
    this.observer.observe(this.bodyNode, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  // 关闭监测，移除水印蒙版
  offWatchWatermaskChange() {
    this.observer.disconnect();
    console.log('关闭监测');
    setTimeout(() => {
      const canvasEl = document.querySelector('#watermask');
      // 移除旧的水印canvas
      this.bodyNode.removeChild(canvasEl);
    }, 310);
  }
}
